import React from "react"
import DOMPurify from "dompurify"
import { Modal, Empty, Spin, Typography } from "@mimber/ui-web"
import { useCommunicationTemplate } from "@mimber/client/mimber-organization"
import { renderTemplateVariables } from "@mimber/schema"
import type { AnnouncementPreviewModalProps } from "./AnnouncementPreviewModal.types"
import {
  SAMPLE_VARIABLE_CONTEXT,
  CHANNEL_LABEL,
} from "./AnnouncementPreviewModal.utils"

const { Text } = Typography

export const AnnouncementPreviewModal: React.FunctionComponent<
  AnnouncementPreviewModalProps
> = ({ templateUuid, channel, ...modalProps }) => {
  const { data, isLoading } = useCommunicationTemplate(templateUuid)
  const template = data?.data

  return (
    <Modal
      footer={null}
      title={`${CHANNEL_LABEL[channel]} Preview`}
      width={720}
      {...modalProps}
    >
      {() =>
        isLoading ? (
          <div
            style={{ textAlign: "center", padding: 48 }}
            data-testid="template-preview-loading"
          >
            <Spin size="large" />
          </div>
        ) : template ? (
          <div data-testid="template-preview-content">
            {template.subject && (
              <div style={{ marginBottom: 12 }}>
                <Text strong>Subject: </Text>
                <Text>
                  {renderTemplateVariables(
                    template.subject,
                    SAMPLE_VARIABLE_CONTEXT
                  )}
                </Text>
              </div>
            )}
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  renderTemplateVariables(
                    template.content,
                    SAMPLE_VARIABLE_CONTEXT
                  )
                ),
              }}
            />
            <div style={{ marginTop: 16 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Variable placeholders (e.g. {"{{member_name}}"}) are shown with
                sample values. Actual values will be substituted per recipient
                at send time.
              </Text>
            </div>
          </div>
        ) : (
          <Empty description="Template not found" />
        )
      }
    </Modal>
  )
}
